
import { HddOutlined, CloseCircleOutlined, SearchOutlined, PlusCircleOutlined, LockOutlined, UserOutlined, CreditCardOutlined, MailOutlined, PhoneOutlined, EditOutlined, DeleteOutlined, ExperimentOutlined, FileProtectOutlined, PieChartOutlined } from '@ant-design/icons';
import { Col, DatePicker, Form, InputRef, Row, TableColumnsType, Tooltip } from 'antd';
import { Button, Input, Space, Table, Modal, InputNumber, Select, Drawer } from 'antd';
import type { ColumnsType, ColumnType } from 'antd/es/table';
import type { FilterConfirmProps, TableRowSelection } from 'antd/es/table/interface';
import React, { useRef, useState, useEffect } from 'react';
import style from '../Tables.module.scss'
import {
    getAllOrganization, getValidateOrganization, putActiveOrganization, postRegisterOrganization, putUpdateOrganization,
    getOrganizationById, deleteInactiveOrganization, deleteOrganizationById,
    getOrganizationsByParentOrganizationId
} from '../../../../store/organization/thunks';
import { connect } from 'react-redux';
import { AppState } from '../../../../store';
import moment from 'moment';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import { validateIdentification, validateLetters, validatePhoneEC, validateBirthday, validateNumber, validateDigitLength, validateLettersAndLength, validate150 } from '../../../../globals/Inputs/validateInput';
import validateMessages from '../../../../globals/Inputs/validateMessages';
import { typesIdentification } from '../../../../globals/Parameters/listParameters';
import locale from 'antd/lib/date-picker/locale/es_ES';
import { Organization } from '../../../../store/organization/types';
import { openNotification } from '../../../../globals/Components/Notification/Notificaction';
import { deleteEmissionsOrganization, getAllEmissionsTable, getEmissionsOrganization, postResgisterEmissionsOrganization } from 'src/store/emissions/thunks';
import { getAllTransformation, GetTransformationById, postRegisterTransformation, putUpdateTransformation } from "src/store/transformationfactors/thunks";
import { EmissionsSource, TypeOrganization } from 'src/store/emissions/types';
import { TransformationSource } from 'src/store/transformationfactors/types';
import { useHistory } from 'react-router-dom';
import { getAllCountry } from 'src/store/catalogue/thunks';
import { Country } from 'src/store/catalogue/types';
import LoadingIndicator from 'src/globals/Components/Loading/LoadingIndicator';
import AdminHeader from 'src/globals/Layout/Admin/AdminHeader';
import TPortafolioOrganizations from './TPortafolioOrganizations';
import TPortafolioEvents from './TPortafolioEvents';



interface UserTableProps {
    dataTableOrganization: DataType[] | undefined;
    getOrganizationsByParentOrganizationId?: any;
    editView?: any;
}

interface DataType {
    key: string;
    id: string;
    ruc: string;
    name: string;
    economicActivity: string;
    description: string;
    msCatalogueCountryId: string;
    msCatalogueCountryName: string;
    organizationParentId: string;
    parentOrganizationId: string;
    status: string;
    createdAt: string;
    typeId: string;
    type: string;
    linkAnalytics: LinkAnalytics[]
}
interface LinkAnalytics {
    id: string,
    url: string,
    service: string,
    createdAt: string,
    updatedAt: string,
    organizationId: string


}
export interface Organizations {
    key: string;
    id: string;
    ruc: string;
    name: string;
    economicActivity: string;
    description: string;
    msCatalogueCountryId: string;
    msCatalogueCountryName: string;
    status: string;
    createdAt: string;
}


interface DataTypeEmission {
    key: string;
    category_name: string;
    emissionOrganizationId: string;
    id: string;
    categoryId: string;
    name: string;
    type: string;
    flow: string;
    co2: string;
    ch4: string;
    n20: string;
    brand: string;
    series: string;
    unit: string;
    description: string;
    createdAt: string;
    updatedAt: string;
}



type DataIndex = keyof DataType;
type DataIndexEmission = keyof DataTypeEmission;
type RequiredMark = boolean | 'optional';
const TPortafolioMyOrganizations: React.FC<UserTableProps> = (props: UserTableProps) => {

    const [dataTable, setDataTable] = useState<DataType[]>([]);
    const history = useHistory();
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef<InputRef>(null);
    const [isCountry, setIsCountry] = useState<Country[]>([]);
    const [selectedCountry, setSelectedCountry] = useState<Country | undefined>();
    const [isModalObservation, setIsModalObservation] = useState(false)


    const [organizationObject, setOrganizationObject] = useState<DataType>();
    const handleSearch = (
        selectedKeys: string[],
        confirm: (param?: FilterConfirmProps) => void,
        dataIndex: DataIndex,
    ) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };

    const handleReset = (clearFilters: () => void) => {
        clearFilters();
        setSearchText('');
    };

    const getColumnSearchProps = (dataIndex: DataIndex, title: string): ColumnType<DataType> => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }} onKeyDown={e => e.stopPropagation()}>
                <Input
                    ref={searchInput}
                    placeholder={`Buscar ${title}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Buscar
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters)}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Reiniciar
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered: boolean) => (
            <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes((value as string).toLowerCase()),
        onFilterDropdownOpenChange: visible => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },

    });
 const openLink = (record:DataType) => {
        const url = process.env.REACT_APP_BASE_URL as string + '/powerbi/' + record.id + "/PORTAFOLIO";
        window.open(url, '_blank');
    };

    const columns: ColumnsType<DataType> = [
        {
            title: '',
            width: 10,
            dataIndex: 'key',
            key: 'key',


        },
        {
            title: '',
            width: 0,
            dataIndex: 'id',
            key: 'id',
            render: () => null,
        },
        {
            title: '',
            width: 0,
            dataIndex: 'msCatalogueCountryId',
            key: 'msCatalogueCountryId',
            render: () => null,
        },
        {
            //cOMO YO QUIERO QUE APAREZCA
            title: 'Nombre',
            width: 60,
            //TA LCUAL COMO SE DECLARA EN EL DATATYPE
            dataIndex: 'name',
            //SE ENVIA EL MISMO QUE EL DATATYPE
            key: 'name',
            //MANTENER FORMATO
            //fixed: 'left',
            //BUSCADOR MODIFICADO PARA ESPANOL
            ...getColumnSearchProps('name', 'nombre'),
            sorter: (a, b) => {
                const dateA = new Date(a.name);
                const dateB = new Date(b.name);

                if (isNaN(dateA.getTime())) {
                    return -1;
                }
                if (isNaN(dateB.getTime())) {
                    return 1;
                }

                return dateA.getTime() - dateB.getTime();
            },
        },
        {
            title: 'RUC',
            width: 50,
            dataIndex: 'ruc',
            key: 'ruc',
            //fixed: 'left',
            ...getColumnSearchProps('ruc', 'ruc'),
        },

        {
            title: 'Actividad económica',
            dataIndex: 'economicActivity',
            key: 'economicActivity',
            width: 50,
            ...getColumnSearchProps('economicActivity', 'Actividad'),
            render: (text, record) => (
                <span style={{ fontSize: '12px', lineHeight: '0.1' }}>{text}</span>
            )
        },
        {
            title: 'Razón social',
            dataIndex: 'description',
            key: 'description',
            width: 70,
            filters: [
                {
                    text: 'Natural',
                    value: 'NATURAL',
                },
                {
                    text: 'Juridica',
                    value: 'JURIDICA',
                },
            ],
            onFilter: (value: string | number | boolean, record) => {
                if (typeof value === 'string') {
                    return record.description.indexOf(value) === 0;
                }
                return false;
            },
            sorter: (a, b) => {
                const dateA = new Date(a.description);
                const dateB = new Date(b.description);

                if (isNaN(dateA.getTime())) {
                    return -1;
                }
                if (isNaN(dateB.getTime())) {
                    return 1;
                }

                return dateA.getTime() - dateB.getTime();
            },

        },
        {
            title: 'País',
            dataIndex: 'msCatalogueCountryName',
            key: 'msCatalogueCountryName',
            width: 40,
            ...getColumnSearchProps('msCatalogueCountryName', 'pais'),
        },
        {
            title: 'Estado',
            dataIndex: 'status',
            key: 'status',
            width: 40,
            filters: [
                {
                    text: 'Activo',
                    value: 'ACTIVO',
                },
                {
                    text: 'Inactivo',
                    value: 'INACTIVO',
                },
            ],
            onFilter: (value: string | number | boolean, record) => {
                if (typeof value === 'string') {
                    return record.status.indexOf(value) === 0;
                }
                return false;
            },
        },
        {
            title: 'Creado',
            dataIndex: 'createdAt',
            key: 'createdAt',
            width: 40,
            defaultSortOrder: 'descend',
            sorter: (a, b) => {
                const dateA = new Date(a.createdAt);
                const dateB = new Date(b.createdAt);

                if (isNaN(dateA.getTime())) {
                    return -1;
                }
                if (isNaN(dateB.getTime())) {
                    return 1;
                }

                return dateA.getTime() - dateB.getTime();
            },
            ...getColumnSearchProps('createdAt', 'creado'),
        },
        {
            title: '',
            key: 'operation',
            fixed: 'right',
            width: 30,

            render: (record: DataType) =>
                <Space size="middle">
                    <Tooltip placement="topRight" title={validateMessages.view} >
                        <Button
                            type="text"
                            className={style["update-button"]}
                            onClick={() => showOrganizationAsociate(record)}
                            icon={<HddOutlined />}
                        >

                        </Button>
                    </Tooltip>
                    <Tooltip placement="topRight" title={"Visualizar observaciones"} >
                        <Button
                            type="text"
                             style={{ display: props.editView ? "none" : "inline-block" }}
                            className={style["update-button"]}
                            onClick={() => {
                                setOrganizationObject(record);
                                setIsModalObservation(true);
                            }}

                            icon={<FileProtectOutlined />}
                        >

                        </Button>
                    </Tooltip>
                    {record.linkAnalytics?.some(item => item.service === "PORTAFOLIO") && (
                        <Tooltip placement="topRight" title={"Visualizar Power Bi"} >
                            <Button
                                type="text"
                                
                                className={style["powerbi-button"]}
                                onClick={() => {
                                    openLink(record)
                                }}
                                icon={<PieChartOutlined />}
                            />
                        </Tooltip>
                    )}


                </Space>,
        },

    ];
    const [showTables, setShowTables] = useState([]);
    const showOrganizationAsociate = async (value: DataType) => {
        
        setOrganizationObject(value);
        const responseData = await props.getOrganizationsByParentOrganizationId(value.id);
        setShowTables(responseData);
    };








    const [isModalDeleteMethodOpen, setIsModalDeleteMethodOpen] = useState(false);
    const [isIdData, setIdData] = useState<String>("");


    const handleDeleteMethodCancel = () => {
        setIsModalDeleteMethodOpen(false);
    };
    const handleTypeDeleteButton = async (value: String) => {
        setIdData(value);
        setIsModalDeleteMethodOpen(true);

    }

    const handleCountryChange = (selectedId: string) => {
        const selected = isCountry.find((country) => country.id === selectedId);
        setSelectedCountry(selected);
    };

    return (
        <>

            <Table size="small" columns={columns} dataSource={props.dataTableOrganization} scroll={{ x: 1500 }} />

            <TPortafolioOrganizations organizationsTable={showTables} organizationObject={organizationObject} editView={props.editView} />

            <Modal width={'90%'} open={isModalObservation} footer={null} onCancel={() => setIsModalObservation(false)}>
                <TPortafolioEvents organizationData={organizationObject} />
            </Modal>

        </>
    );


};

const mapStateToProps = (state: AppState) => ({

});

export default connect(mapStateToProps, {
    getOrganizationsByParentOrganizationId
})(TPortafolioMyOrganizations);